// extracted by mini-css-extract-plugin
export default {"imageWrapper":"aH-z","twoColumnImage":"bH-z"};